import { useEffect, useRef } from 'react'

/** Keep an open admin view in sync without polling while the tab is hidden. */
export function useVisibleRefresh(refresh: () => void, enabled = true, intervalMs = 5000) {
  const refreshRef = useRef(refresh)
  refreshRef.current = refresh

  useEffect(() => {
    if (!enabled) return
    let lastRefresh = Date.now()
    const run = () => {
      if (document.visibilityState !== 'visible' || Date.now() - lastRefresh < 1000) return
      lastRefresh = Date.now()
      refreshRef.current()
    }
    const timer = window.setInterval(run, intervalMs)
    document.addEventListener('visibilitychange', run)
    window.addEventListener('focus', run)
    return () => {
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', run)
      window.removeEventListener('focus', run)
    }
  }, [enabled, intervalMs])
}
